/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newpatient_Privacyconsentsuffix3Inputs */

const en_newpatient_privacyconsentsuffix3 = /** @type {(inputs: Newpatient_Privacyconsentsuffix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

const fr_newpatient_privacyconsentsuffix3 = /** @type {(inputs: Newpatient_Privacyconsentsuffix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

/**
* | output |
* | --- |
* | "." |
*
* @param {Newpatient_Privacyconsentsuffix3Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const newpatient_privacyconsentsuffix3 = /** @type {((inputs?: Newpatient_Privacyconsentsuffix3Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newpatient_Privacyconsentsuffix3Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_newpatient_privacyconsentsuffix3(inputs)
	return fr_newpatient_privacyconsentsuffix3(inputs)
});
export { newpatient_privacyconsentsuffix3 as "newPatient_privacyConsentSuffix" }